'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  GOOGLE_ADSWORDS_ACTIVATION: 'pIzkCLzq7WIQnKTV1QM',
  FACEBOOK_SMARTPIXEL_ID: '1657797781133784',
  FACEBOOK_PAGEVIEW_LATAM: '1577323492557160',
  GOOGLE_ADWORDS_SIGNUP1: 'q-XzCISP_2IQnKTV1QM',
  TWITTER_ADS_SIGNUP_FORM: 'ntmgl',
  BING_ADS: '5576715',
  QUORA_USER_CREATE: '2b78739bf31f6defc775d6fb70fdf19d',
  CLICKMETER_CRM_SIGNUP: '502A40B45E5349A094856C3D35AD4FF9'
};
module.exports = exports['default'];